import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

interface ChartSkeletonProps {
  height?: number;
  className?: string;
}

export default function ChartSkeleton({
  height = 280,
  className,
}: ChartSkeletonProps) {
  return (
    <Card className={`border-ctu-border shadow-none ${className ?? ''}`}>
      <CardContent className="flex flex-col gap-3 px-6 pt-5 pb-4">
        <div className="flex flex-col gap-1.5">
          <Skeleton className="h-3 w-44" />
          <Skeleton className="h-3 w-3/4 max-w-[28rem]" />
        </div>
        <Skeleton
          className="w-full rounded-md"
          style={{ height }}
          aria-hidden
        />
      </CardContent>
    </Card>
  );
}
